export const parseFilterValues = (value) => {
  if (value == null) return [];

  const rawItems = Array.isArray(value) ? value : [value];

  return rawItems.flatMap((item) => {
    const str = String(item ?? '').trim();
    if (!str || str.toLowerCase() === 'все') return [];

    return str
      .split(';')
      .map((part) => part.trim())
      .filter(Boolean);
  });
};

export const publicationFilterMatches = (filterField, selectedValue) => {
  if (!selectedValue || selectedValue === 'все') return true;

  const values = parseFilterValues(filterField);
  if (values.length === 0) return false;

  return values.includes(String(selectedValue).trim());
};

export const findFilterImage = (filterField, imgsForFilters) => {
  if (!filterField || !Array.isArray(imgsForFilters) || imgsForFilters.length === 0) {
    return null;
  }

  const values = parseFilterValues(filterField);
  for (const value of values) {
    const matched = imgsForFilters.find((item) => item.word === value);
    if (matched?.img) return matched.img;
  }

  return null;
};
